import { Component } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { SelectComponent } from '@shared/components/select/select.component';

// Use same array instance for empty options instead of instantiating a new array each time, otherwise lib-select gets
// stuck in an infinite update loop
const emptyOptions: any[] = [];

@Component({
  templateUrl: 'multiselect.component.html',
  styleUrls: ['multiselect.component.scss'],
  imports: [
    SelectComponent,
  ],
})
export class MultiSelectFieldTypeComponent extends FieldType {
  public static readonly defaultOptions: FormlyFieldConfig = {
    defaultValue: [],
    props: {
      placeholder: 'Please select...',
    },
  };

  public get selectedOptionsValues(): unknown[] {
    const selectedOptions = this.formControl.value;
    return Array.isArray(selectedOptions) ? selectedOptions : emptyOptions;
  }

  public get optionsArray(): any[] {
    return (this.props.options as any[]) ?? emptyOptions;
  }

  public get isReadonly(): boolean {
    return !!this.props.readonly || !!this.props.disabled;
  }
}
